import * as RxTabs from '@radix-ui/react-tabs';
import { ReactNode, useState } from 'react';

import Text from '../base/Text';

export type Tab = {
  value: string;
  label: ReactNode;
  content: ReactNode;
};

export default function Tabs({
  className,
  defaultValue,
  onChange,
  tabs,
  tabListClassName,
}: {
  className?: string;
  defaultValue?: Tab['value'];
  onChange?: (value: Tab['value']) => void;
  tabs: Tab[];
  tabListClassName?: string;
}) {
  const [activeTab, setTab] = useState<Tab['value']>(
    defaultValue || tabs[0].value,
  );

  return (
    <RxTabs.Root
      value={activeTab}
      onValueChange={(value: string) => {
        setTab(value);
        onChange?.(value);
      }}
      className={`flex flex-col gap-4 md:flex-row ${className}`}
    >
      <div className="flex flex-col gap-4">
        <RxTabs.List
          className={`md:no-scrollbar mt-1.5 flex w-[calc(100%+32px)] flex-none gap-2 overflow-x-scroll whitespace-nowrap md:w-[180px] md:flex-col md:overflow-x-hidden ${tabListClassName}`}
        >
          {tabs.map((tab) => (
            <RxTabs.Trigger
              key={tab.value}
              value={tab.value}
              className={`hover:bg-gray-15 dark:hover:bg-gray-60 flex h-10 items-center rounded-lg border px-2 pt-0.5 text-left transition-colors md:border-0 md:px-4 ${
                activeTab === tab.value
                  ? 'bg-gray-15 hover:bg-gray-15 dark:bg-gray-75 dark:hover:bg-gray-75 cursor-default'
                  : ''
              }`}
            >
              {typeof tab.label === 'string' ? (
                <Text variant="studio/body/medium/sm">{tab.label}</Text>
              ) : (
                tab.label
              )}
            </RxTabs.Trigger>
          ))}
        </RxTabs.List>
      </div>

      {tabs.map((tab) => (
        <RxTabs.Content
          key={tab.value}
          value={tab.value}
          className="min-w-0 flex-auto"
        >
          {tab.content}
        </RxTabs.Content>
      ))}
    </RxTabs.Root>
  );
}
